/**
 * Scope of work revision calls for the secure link flow (/link/scope-of-work-revision): loan-service's
 * @SecureLinkEndpoint endpoints, authorized by the secure link session (Authorization: Bearer). Never sends a draw id
 * or username: the server takes the revision draw from the session.
 */
const BASE = '/api/v1/loan/secure-link/sow-revision';

export type SecureLinkRequest = <T>(path: string, init?: RequestInit) => Promise<T>;

/** The revision (nportal PublicSowRevisionResponse): the scope of work as JSON text. */
export interface SowRevisionLinkData {
  dataContent: string;
  originalData?: string;
}

/** nportal's answer to a submit; success is false when the revision can no longer be changed. */
export interface SowRevisionSubmitResponse {
  success: boolean;
  responseMessage?: string;
}

export class SecureLinkScopeOfWorkRevisionService {
  constructor(private readonly request: SecureLinkRequest) {}

  getData() {
    return this.request<SowRevisionLinkData>(`${BASE}/data`);
  }

  getCategories() {
    return this.request<any[]>(`${BASE}/categories`);
  }

  getSplitCategories() {
    return this.request<any[]>(`${BASE}/split-categories`);
  }

  getSubmissionErrors(data: any, version: number) {
    return this.request<any>(`${BASE}/submission-errors?version=${encodeURIComponent(version)}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  submit(data: any) {
    return this.request<SowRevisionSubmitResponse>(`${BASE}/submit`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
